// Shown in the thumbnail preview if the image doesn't load

import styled from '@emotion/styled';
import { Divider, Typography } from 'antd';
import type { FC, ReactNode } from 'react';
import { OmnitagResultItem } from 'packages/lib/api/omnitag/contract/omnitag-search';

const MetaData = styled.div`
  background-color: white;
  padding: 1rem;
  display: none;
  .label {
    margin-right: 1rem;
    margin-bottom: 0.5rem;
    width: 10ch;
    display: inline-block;
  }

  div:not(:root):fullscreen & {
    display: block;
  }
`;

function Item({
  label,
  children,
}: {
  label: string;
  children: ReactNode;
}): JSX.Element {
  return (
    <div>
      <Typography.Text strong className="label">
        {label}
      </Typography.Text>
      {children}
    </div>
  );
}

interface ResultMetaProps {
  result: OmnitagResultItem;
}

export const ResultMeta: FC<React.PropsWithChildren<ResultMetaProps>> = ({
  result,
}): JSX.Element => {
  return (
    <MetaData className="metaContainer" style={{ backgroundColor: 'white' }}>
      <Typography.Title level={2}>Meta Data</Typography.Title>
      <Divider />
      <Item label="Log">
        <Typography.Text copyable>{result.log_name}</Typography.Text>
      </Item>
      <Item label="Channel">
        <Typography.Text copyable>{result.channel}</Typography.Text>
      </Item>
      <Item label="Timestamp">
        <Typography.Text copyable>
          {result.timestamp.toString()}
        </Typography.Text>
      </Item>
    </MetaData>
  );
};
